module.exports = __webpack_public_path__ + "static/img/27007.73df38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/stockUniverse/27007.png
// module id = l/Pi
// module chunks = 0